function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 =
/*#__PURE__*/
React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M28.683 18.344H11.317c-.537 0-.972-.419-.972-.935 0-.517.435-.935.971-.935h.828c.441-3.458 3.294-6.205 6.885-6.63V7.935c0-.516.435-.935.97-.935.537 0 .972.418.972.935v1.91c3.59.424 6.444 3.171 6.885 6.629h.827c.537 0 .971.418.971.935 0 .516-.434.935-.97.935zm-2.787-1.87c-.466-2.73-2.932-4.82-5.896-4.82s-5.43 2.09-5.895 4.82h11.79zM29.138 31.13h.891c.536 0 .971.419.971.935 0 .517-.435.935-.971.935H9.971C9.435 33 9 32.581 9 32.065s.435-.935.971-.935h.89v-4.846h-.89c-.536 0-.971-.418-.971-.935 0-.516.435-.935.971-.935h2.111v-2.977h-.765c-.537 0-.971-.419-.971-.935 0-.517.434-.935.97-.935h17.367c.537 0 .971.418.971.935 0 .516-.434.935-.97.935h-.766v2.977h2.111c.536 0 .971.419.971.935 0 .517-.435.935-.971.935h-.89v4.846zm-4.084 0h2.142v-4.846h-2.142v4.846zm-4.083-6.716h1.531v-2.977h-1.531v2.977zm-3.473 0h1.531v-2.977h-1.531v2.977zm1.531 1.87h-2.142v4.846h2.142v-4.846zm4.084 0H20.97v4.846h2.142v-4.846zm1.331-1.87h1.532v-2.977h-1.532v2.977zm-8.888-2.977h-1.532v2.977h1.532v-2.977zm-.61 4.847h-2.142v4.846h2.141v-4.846z",
  fill: "currentColor"
});

var SvgAudienceWorldview = function SvgAudienceWorldview(_ref) {
  var svgRef = _ref.svgRef,
      props = _objectWithoutProperties(_ref, ["svgRef"]);

  return React.createElement("svg", _extends({
    viewBox: "0 0 40 40",
    width: 40,
    height: 40,
    fill: "none",
    ref: svgRef
  }, props), _ref2);
};

var ForwardRef = React.forwardRef(function (props, ref) {
  return React.createElement(SvgAudienceWorldview, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/audience_worldview.82b7ff98.svg";
export { ForwardRef as ReactComponent };